import React from "react";
import { Card, Button, Avatar } from "antd";
import { EyeOutlined, MailOutlined } from "@ant-design/icons";
import { cn } from "../../../../../utils/cn";
import { formatDateTime } from "../../../../../utils/functions";
import { getInitials } from "../../../../../utils/helper";

const EnhancedEmailLogCardView = ({
    record,
    actions = [],
    onCardClick,
}) => {
    const initials = getInitials(record.userEmail);

    return (
        <Card
            hoverable
            className="h-full relative"
            onClick={() => onCardClick && onCardClick(record)}
        >
            <div className="space-y-4">
                {/* Header */}
                <div className="flex items-start justify-between">
                    <div className="flex items-center space-x-3 overflow-hidden">
                        <Avatar
                            size={48}
                            className="flex-shrink-0 font-semibold text-lg !bg-primary"
                        >
                            {initials}
                        </Avatar>
                        <div className="min-w-0 flex-1">
                            <h3 className="font-semibold text-base mb-1 truncate" title={record.userEmail}>
                                {record.userEmail || "N/A"}
                            </h3>
                            <div className="flex items-center text-sm text-gray-500">
                                <MailOutlined className="mr-1 flex-shrink-0" />
                                <span className="truncate" title={record.emailTo}>
                                    To: {record.emailTo}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>

                {/* Body */}
                <div className="space-y-2">
                    <div className="flex items-center justify-between text-sm text-gray-600">
                        <span className="font-medium">Sent At:</span>
                        <span>{formatDateTime(record.createdAt)}</span>
                    </div>
                    {/* Message Preview */}
                    <div className="mt-2">
                        <span className="font-medium text-sm text-gray-600 block mb-1">Message Preview:</span>
                        <div
                            className="text-sm text-gray-500 line-clamp-3 bg-gray-50 p-2 rounded border border-gray-100"
                            dangerouslySetInnerHTML={{ __html: record.emailBody }}
                        />
                    </div>
                </div>
            </div>
        </Card>
    );
};

export default EnhancedEmailLogCardView;
